<style scoped>
  .text-center{text-align: center}
  input{background-color:#ffea9f;border: none;text-align: center}
</style>
<template>
  <div>
    <p style="font-size:24pt;" class="text-center">
      法 律 事 务 委 托 合 同
    </p>
    <p style="font-size: 14pt;text-align: center">（刑 事）</p>
    <div style="padding:20px"></div>
    <!--<p style="text-align:right;font-size:14pt">合同编号：琼云联律刑字[<input style="width:2em" v-model="text[0]"></input>]第<input style="width:5em" v-model="text[1]"></input>号</p>-->
    <div style="padding:20px"></div>
    <p style="text-indent:2em;font-size:14pt;font-family:Simsun">聘请方（甲方）：<input style="width:5em" v-model="text[2]"></input></p>
    <p style="text-indent:2em;font-size:14pt;font-family:Simsun">受聘方（乙方）：{{$store.state.userInfo.companyName}}</p>
    <p style="text-indent:2em;font-size:14pt;font-family:Simsun">根据中华人民共和国《合同法》、《刑事诉讼法》、《律师法》及其他有关法律的规定，甲方聘请/委托乙方律师为<input style="width:5em" v-model="text[3]"></input>提供法律帮助/辩护。双方按照诚实信用原则，经协商一致，立此合同，共同遵守。</p>
    <p style="text-indent:2em;font-size:14pt;font-family:Simsun">第一条 甲方聘请/委托乙方律师为<input style="width:5em" v-model="text[4]"></input>在<input style="width:5em" v-model="text[5]"></input>，以维护犯罪嫌疑人（被告人）的合法权益</p>
    <p style="text-indent:2em;font-size:14pt;font-family:Simsun">1、侦查阶段提供法律帮助</p>
    <p style="text-indent:2em;font-size:14pt;font-family:Simsun">2、审查起诉阶段提供辩护</p>
    <p style="text-indent:2em;font-size:14pt;font-family:Simsun">3、一审阶段提供辩护</p>
    <p style="text-indent:2em;font-size:14pt;font-family:Simsun">4、二审阶段提供辩护</p>
    <p style="text-indent:2em;font-size:14pt;font-family:Simsun">5、申诉阶段提供法律帮助与辩护</p>
    <p style="text-indent:2em;font-size:14pt;font-family:Simsun">第二条 乙方接受委托后，除因乙方律师不能控制的原因外，应根据委托的范围和案件的进展，在相应的阶段中，按法律规定及办案机关的安排，完成以下工作。</p>
    <p style="text-indent:2em;font-size:14pt;font-family:Simsun">（一）侦查阶段：1、向侦查机关了解犯罪嫌疑人涉嫌的罪名；2、会见犯罪嫌疑人，为犯罪嫌疑人提供法律咨询；3、对侵犯犯罪嫌疑人合法权益的行为代为申诉、控告；4、认为犯罪嫌疑人涉嫌的犯罪事实不成立的，向侦查机关提出法律意见；5、为符合取保候审或监视居住法定条件的犯罪嫌疑人申请取保候审或监视居住。</p>
    <p style="text-indent:2em;font-size:14pt;font-family:Simsun">（二）审查起诉阶段：1、查阅、了解、复制本案的诉讼文书、技术性鉴定材料；2、会见犯罪嫌疑人，向其了解有关案情；3、必要时，依法向有关单位和个人收集与本案有关的材料；4、对有《刑事诉讼法》第十五条规定的情形之一的犯罪嫌疑人、被告人，向人民检察院提出书面法律意见。</p>
    <p style="text-indent:2em;font-size:14pt;font-family:Simsun">（三）一审阶段：1、查阅、了解、复制检察机关向人民法院移送的主要证据复印件、起诉书和相关材料；2、会见被告人，了解其对起诉书指控的意见及对案情的陈述；3、必要时，依法向有关单位和个人收集与本案有关的材料；4、按时出庭，依法为被告人辩护，向法院提交书面一审辩护意见。</p>
    <p style="text-indent:2em;font-size:14pt;font-family:Simsun">（四）二审阶段：1、查阅、了解本案的一审判决，根据需要复制相关案件材料，应上诉人的要求起草上诉书；2、会见上诉人，了解其对一审判决的意见及对案情的陈述；3、按时出庭，依法为上诉人辩护，向法院提交面二审辩护意见。</p>
    <p style="text-indent:2em;font-size:14pt;font-family:Simsun">（五）申诉阶段：1、查阅、了解本案的判决情况和相关卷宗材料，应申诉人的要求起草申诉书；2、会见申诉人，了解其对生效判决的意见及对案情的陈述；3、如获进入再审，按时出庭，依法为申诉人辩护，向法院提交书面再审辩护意见。</p>
    <p style="text-indent:2em;font-size:14pt;font-family:Simsun">第三条 甲方的权利和义务</p>
    <p style="text-indent:2em;font-size:14pt;font-family:Simsun">（一）甲方应当真实、客观、全面地向乙方介绍案情；如与本案有关的情况和事实发生变化，应及时告知乙方律师。</p>
    <p style="text-indent:2em;font-size:14pt;font-family:Simsun">（二）甲方应当积极主动地配合乙方律师的工作，对乙方律师提出的要求应当明确具体、合法合理；不得要求乙方律师进行违法或者有违律师执业规范的活动。</p>
    <p style="text-indent:2em;font-size:14pt;font-family:Simsun">（三）甲方应当依约按时、足额地向乙方支付律师服务费和差旅费等。</p>
    <p style="text-indent:2em;font-size:14pt;font-family:Simsun">（四）甲方有权要求乙方及时更换在服务过程中工作不负责任、或不适合办理甲方委托的法律事务的乙方律师，但甲方提出此要求的理由应充分、合理。</p>
    <p style="text-indent:2em;font-size:14pt;font-family:Simsun">（五）甲方有权要求乙方复印与委托的法律事务相关的材料，但法律法规和律师执业规范规定应当保密的材料除外。</p>
    <p style="text-indent:2em;font-size:14pt;font-family:Simsun">第四条 乙方的权利和义务</p>
    <p style="text-indent:2em;font-size:14pt;font-family:Simsun">（一）乙方指派<input style="width:5em" v-model="text[6]"></input>律师为<input style="width:5em" v-model="text[7]"></input> 提供本合同第二条第（<input style="width:1em" v-model="text[8]"></input>）项约定的服务。该指派律师因故不能履行职务时，由乙方另行指派律师，经甲方确认并重新出具授权委托书后，继续完成本合同约定的委托事务。如需开庭的，另行指派的律师应有合理的时间熟悉案情，保证开庭的质量。</p>
    <p style="text-indent:2em;font-size:14pt;font-family:Simsun">（二）乙方律师应当依法依理、勤勉尽责地提供法律帮助或辩护，切实维护犯罪嫌疑人（被告人）的合法权益，并应甲方合理要求通报工作进程。</p>
    <p style="text-indent:2em;font-size:14pt;font-family:Simsun">（三）乙方律师对获知的犯罪嫌疑人（被告人）的商业秘密或个人隐私负有保密责任，非因法律规定或者其本人同意，不得向任何第三方披露。</p>
    <p style="text-indent:2em;font-size:14pt;font-family:Simsun">（四）如甲方或犯罪嫌疑人（被告人）隐瞒案情事实真相或要求乙方律师从事违反法律或律师执业规范的活动，乙方有权拒绝。</p>
    <p style="text-indent:2em;font-size:14pt;font-family:Simsun">第五条 本合同生效后，甲乙双方均可依法解除合同，因解除合同给对方造成损失的，除不可归责于解除合同一方的事由外，应当赔偿对方因此而发生的损失，赔偿金额以乙方实际收到的律师服务费为限。</p>
    <p style="text-indent:2em;font-size:14pt;font-family:Simsun">第六条 费用的确定与支付</p>
    <p style="text-indent:2em;font-size:14pt;font-family:Simsun">（一）收费依据：国家和海南省律师服务收费的现行有效规定。</p>
    <p style="text-indent:2em;font-size:14pt;font-family:Simsun">（二）律师服务费：双方协商确定采用如下第<input style="width:1em" v-model="text[9]"></input>种方式。</p>
    <p style="text-indent:2em;font-size:14pt;font-family:Simsun">计件方式：甲方应向乙方支付律师服务费人民币<input style="width:5em" v-model="text[10]"></input>元。</p>
    <p style="text-indent:2em;font-size:14pt;font-family:Simsun">付费时间为下列第<input style="width:1em" v-model="text[11]"></input>种。</p>
    <p style="text-indent:2em;font-size:14pt;font-family:Simsun">（1）在本合同签订生效之日起<input style="width:1em" v-model="text[12]"></input>日内一次性支付；</p>
    <p style="text-indent:2em;font-size:14pt;font-family:Simsun">2、其他约定：<input style="width:10em" v-model="text[13]"></input></p>
    <p style="text-indent:2em;font-size:14pt;font-family:Simsun">2、计时方式：甲方应按每小时人民币<input style="width:10em" v-model="text[14]"></input>元向乙方支付律师服务费。计时清单由双方根据案件的情况另行确定。</p>
    <p style="text-indent:2em;font-size:14pt;font-family:Simsun">付费时间为：<input style="width:5em" v-model="text[15]">。</p>
    <p style="text-indent:2em;font-size:14pt;font-family:Simsun">无论选择上述何种方式计付律师服务费，甲方均应以现金或转账方式直接向乙方支付并索取有效发票；向乙方律师个人或其他个人支付的，乙方均不予认可。本合同落款处的乙方账户为收费账户。</p>
    <p style="text-indent:2em;font-size:14pt;font-family:Simsun">乙方收到甲方支付的律师服务费，不论是一次性支付还是分期支付，均应在收到款项后及时开具有效发票，最迟不超过15个工作日。</p>
    <p style="text-indent:2em;font-size:14pt;font-family:Simsun">（三）乙方律师在完成甲方的法律事务过程中发生的差旅费、诉讼费（仲裁费）、保全费、鉴定费、评估费、公证费、公告费、查档费等费用，由甲方另行支付。</p>
    <p style="text-indent:2em;font-size:14pt;font-family:Simsun">（四）甲方逾期支付律师服务费的，从逾期之日起，按应付金额每日万分之六支付违约金。经乙方催告后仍未支付律师服务费的，乙方有权解除合同，但应当通知甲方。</p>
    <p style="text-indent:2em;font-size:14pt;font-family:Simsun">第七条 第七条 因乙方律师的过错行为导致甲方蒙受损失，乙方通过其投保的执业保险向甲方承担过错赔偿责任，赔偿金额以乙方投保的执业保险金额为限。</p>
    <p style="text-indent:2em;font-size:14pt;font-family:Simsun">第九条 甲方确认下列通讯方式及联系人是乙方办理本合同委托事务向甲方履行通知义务的通讯方式及联系人：</p>
    <p style="text-indent:2em;font-size:14pt;font-family:Simsun"><input style="width:10em" v-model="text[16]"></input></p>
    <p style="text-indent:2em;font-size:14pt;font-family:Simsun">如果甲方变更通讯方式或联系人,需提前七日书面通知乙方。</p>
    <p style="text-indent:2em;font-size:14pt;font-family:Simsun">第九条 因履行本合同发生争议，双方应友好协商；协商不成的，可选择下列第<input style="width:1em" v-model="text[17]"></input>种方式解决：</p>
    <p style="text-indent:2em;font-size:14pt;font-family:Simsun">1、提交海南仲裁委员会仲裁；</p>
    <p style="text-indent:2em;font-size:14pt;font-family:Simsun">2、向人民法院提起诉讼。</p>
    <p style="text-indent:2em;font-size:14pt;font-family:Simsun">第十条 本合同一式<input style="width:2em" v-model="text[18]"></input>份，双方各执<input style="width:2em" v-model="text[19]"></input>份，自双方签字盖章之日起效。</p>
    <p style="text-indent:2em;font-size:14pt;font-family:Simsun">第十一条 甲方承诺：已认真审阅本合同所有格式条款并完全了解其详尽内容；本合同所有条款均属双方平等且完全协商一致而达成。</p>
    <p style="text-indent:2em;font-size:14pt;font-family:Simsun">第十二条 未尽审宜，双方可在本条另行特别约定：<input style="width:35em" v-model="text[20]"></input></p>
    <div style="padding:20px"></div>
    <Row style="font-size:14pt;font-family:SimSun">
      <Col span="12">
        <Row>
          <Col span="5" style="text-align: right">甲方：</Col>
          <Col span="19"><input style="width:10em" v-model="text[21]"></input></Col>
        </Row>
        <div style="padding:5px"></div>
        <Row>
          <Col span="5" style="text-align: right">法定代表人：</Col>
          <Col span="19"><input style="width:10em" v-model="text[22]"></Col>
        </Row>
        <div style="padding:5px"></div>
        <Row>
          <Col span="5" style="text-align: right">地址：</Col>
          <Col span="19"><input style="width:10em" v-model="text[23]"></Col>
        </Row>
        <Row>
          <Col span="5" style="text-align: right">电话：</Col>
          <Col span="19"><input style="width:10em" v-model="text[24]"></Col>
        </Row>
        <Row>
          <Col span="5" style="text-align: right">开户行：</Col>
          <Col span="19"><input style="width:10em" v-model="text[25]"></Col>
        </Row>
        <Row>
          <Col span="5" style="text-align: right">账号：</Col>
          <Col span="19"><input style="width:10em" v-model="text[26]"></Col>
        </Row>
      </Col>
      <Col span="12">
        <Row>
          <Col span="5" style="text-align: right">乙方：</Col>
          <Col span="19"><input style="width:10em" v-model="text[27]"></Col>
        </Row>
        <div style="padding:5px"></div>
        <Row>
          <Col span="5" style="text-align: right">法定代表人：</Col>
          <Col span="19"><input style="width:10em" v-model="text[28]"></Col>
        </Row>
        <div style="padding:5px"></div>
        <Row>
          <Col span="5" style="text-align: right">地址：</Col>
          <Col span="19"><input style="width:10em" v-model="text[29]"></Col>
        </Row>
        <Row>
          <Col span="5" style="text-align: right">电话：</Col>
          <Col span="19"><input style="width:10em" v-model="text[30]"></Col>
        </Row>
        <Row>
          <Col span="5" style="text-align: right">开户行：</Col>
          <Col span="19"><input style="width:10em" v-model="text[31]"></Col>
        </Row>
        <Row>
          <Col span="5" style="text-align: right">账号：</Col>
          <Col span="19"><input style="width:10em" v-model="text[32]"></Col>
        </Row>
      </Col>
    </Row>
    <p style="text-align: right;font-size:14pt;font-family:Simsun">签约日期：<input style="width:2em" v-model="text[33]">年<input style="width:2em" v-model="text[34]">月<input style="width:2em" v-model="text[35]">日</p>
    <p style="text-align: center;font-size:14pt;font-family:Simsun"><input style="width:100%" v-model="text[36]"></input></p>
    <div style="padding:10px"></div>
    <div style="text-align: center">
      <Button type="primary" style="width:200px" @click="saveContract()">保 存 合 同</Button>
      <Button type="success" style="width:200px;margin-left:50px" @click="approvalContract()">发 起 合 同 盖 章 审 批</Button>    </div>
  </div>
</template>
<script>
  export default {
    name: "criminal",//刑事
    data:function(){
      return{
        text:[],
        client:[],
        opposed:[],
        userList:[],
        caseInfo:{},
      }
    },
    mounted:function () {
      this.getContractContent()
      this.getLitigationList()
    },
    methods:{
      approvalContract:function(){
        var _this = this
        _this.saveContract(function () {
          _this.send({
            headers:'V/FileCreate',
            data:{
              CaseId:_this.$route.query.caseId
            },
            success:function (res) {
              if(!_this.isEmpty(res)){
                var src = res.substr(('/home/wwwroot/'+SYSCONFIG.server.default.host+'/public/').length+1,res.length)
              }else{
                _this.$Notice.errpr({
                  title:'系统消息',
                  desc:'网络繁忙！'
                })
              }
              var approvalData = [
                {"name":"approvalInput","content":{"title":"案号","text":_this.caseInfo.case_num,"must":false,"allowSubmission":true}},
                {"name":"approvalFile","content":{"title":"文件","fileName":"合同文件","filesSrc":src,"seal":"1","must":false,"allowSubmission":true}}
              ]
              var modeId
              if(window.sessionStorage.groupId==1){
                modeId=2
              }else{
                modeId=36
              }
              _this.send({
                headers:'L/AddApproval',
                data:{
                  ExcessAssessors:_this.caseInfo.case_executor_id,
                  ApprovalModeId:modeId,
                  CaseId:_this.$route.query.caseId,
                  ApprovalContent:approvalData,
                },
                success:function () {
                  _this.$Notice.success({
                    title:'系统消息',
                    desc:'发起审批成功！'
                  })
                  _this.$router.push({name:'projectList'})
                }
              })
            }
          })
        })
      },
      saveContract:function(callback){
        var _this = this
        _this.send({
          headers:'V/UpdateVisaFile',
          data:{
            CaseId:_this.$route.query.caseId,
            ContractFileContent:_this.text,
          },
          success:function (res) {
            // _this.$router.push({name:'projectSeal',query:{caseId:_this.$route.query.caseId,taskId:_this.$route.query.taskId}})
            _this.$Notice.success({
              title:'系统消息',
              desc:'保存成功！'
            })
            if(callback){
              callback()
            }
          }
        })
      },
      //获取当事人列表
      getLitigationList:function(){
        var _this = this
        _this.send({
          headers:'E/LitigatsList',
          data:{
            CaseId:_this.$route.query.caseId,
          },
          success:function (res) {
            _this.client = []
            _this.opposed = []
            for(var index in res){
              if(res[index].LitigationStatusId==1){
                _this.client.push({
                  id:res[index].LitigantId,
                  name:res[index].LitigantName,
                  litigation:res[index].LawsuitId,
                  identity :res[index].LitigantTypeId,
                  IDCardCode:res[index].LitigantIdCard,
                })
              }
              if(res[index].LitigationStatusId==2){
                _this.opposed.push({
                  id:res[index].LitigantId,
                  name:res[index].LitigantName,
                  litigation:res[index].LawsuitId,
                  identity :res[index].LitigantTypeId,
                  IDCardCode:res[index].LitigantIdCard,
                })
              }
            }
            _this.getUserList()
          }
        })
      },
      //获取用户数据
      getUserList:function(searchText){
        var _this = this
        _this.userList = []
        _this.send({
          headers:'C/LawList',
          data:{
            key:searchText||'',
          },
          success:function (res) {
            var tempObj = []
            for(var index in res){
              tempObj.push({id:res[index].UserId,name:res[index].UserName,icon:res[index].UserImg})
            }
            _this.userList = tempObj
            _this.selectUserList = tempObj
            _this.projectRegister()
          }
        })
      },
      //获取案件数据
      projectRegister: function () {
        var _this = this
        _this.send({
          headers: "E/ShowSingleCase",
          data: {
            CaseId: _this.$route.query.caseId
          },
          success: function (res) {
            _this.caseInfo = res
            var clientArr = []
            for(var index in _this.client){
              clientArr.push(_this.client[index].name)
            }
            var lawArr = []
            for(var index in res.case_executor_id.split(',')){
              if(_this.userList.find((secItem)=>{return secItem.id==res.case_executor_id.split(',')[index]})){
                lawArr.push(_this.userList.find((secItem)=>{return secItem.id==res.case_executor_id.split(',')[index]}).name)
              }
            }
            _this.text[2]==null||_this.text[2]==''?_this.$set(_this.text,'2',clientArr.toString()):''
            _this.text[3]==null||_this.text[3]==''?_this.$set(_this.text,'3',lawArr.toString()):''
            _this.text[4]==null||_this.text[4]==''?_this.$set(_this.text,'4',lawArr.toString()):''
            _this.text[6]==null||_this.text[6]==''?_this.$set(_this.text,'6',lawArr.toString()):''
            _this.text[7]==null||_this.text[7]==''?_this.$set(_this.text,'7',clientArr.toString()):''
            // _this.text[15]==null||_this.text[15]==''?_this.$set(_this.text,'15',res.case_linkman+':'+res.case_linkman_tel):''
            // _this.text[20]==null||_this.text[20]==''?_this.$set(_this.text,'20',clientArr.toString()):''
            _this.text[21]==null||_this.text[21]==''?_this.$set(_this.text,'21',clientArr.toString()):''
            _this.text[33]==null||_this.text[33]==''?_this.$set(_this.text,'33',new Date().getFullYear()):''
            _this.text[34]==null||_this.text[34]==''?_this.$set(_this.text,'34',new Date().getMonth()+1):''
            _this.text[35]==null||_this.text[35]==''?_this.$set(_this.text,'35',new Date().getDate()):''
            _this.text[27]=_this.isEmpty(_this.text[27])?_this.$store.state.userInfo.companyName:_this.text[27]
            if(_this.$store.state.userInfo.companyName.indexOf('文昌')!=-1){
              _this.text[28]=_this.isEmpty(_this.text[28])?'魏道言':_this.text[28]
              _this.text[29]=_this.isEmpty(_this.text[29])?'海南省文昌市文城镇文建路49-77-1号五楼':_this.text[29]
              _this.text[30]=_this.isEmpty(_this.text[30])?'（0898）':_this.text[30]
              _this.text[31]=_this.isEmpty(_this.text[31])?'中国农业银行股份有限公司文昌文建支行':_this.text[31]
              _this.text[32]=_this.isEmpty(_this.text[32])?'21344001040002456':_this.text[32]
            }else{
              _this.text[28]=_this.isEmpty(_this.text[28])?'李晶瑜':_this.text[28]
              _this.text[29]=_this.isEmpty(_this.text[29])?'海口市美兰区和平大道20号鹏晖国际大厦第十层':_this.text[29]
              _this.text[30]=_this.isEmpty(_this.text[30])?'（0898）6860 2020':_this.text[30]
              _this.text[31]=_this.isEmpty(_this.text[31])?'招商银行股份有限公司海口分行':_this.text[31]
              _this.text[32]=_this.isEmpty(_this.text[32])?'898901287010666':_this.text[32]
            }
          }
        })
      },

      getContractContent:function () {
        var _this = this
        _this.send({
          headers:'V/VisaFile',
          data:{
            CaseId:_this.$route.query.caseId
          },
          success:function (res) {
            if(res.ContractFileContent){
              _this.$set(_this,'text',res.ContractFileContent)
            }else{
              _this.text.length=37
              for(var i=0;i<_this.text.length;i++){
                _this.text[i]=''
              }
              _this.$set(_this.text,'36','海南省法律服务监督投诉电话：（0898） 65919080、（0898） 66161293')
            }
          }
        })
      }
    }
  }
</script>